import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ItemSelectorComponent} from './item-selector/item-selector.component';
import {ListCounterComponent} from './list-counter/list-counter.component';
import {SetlistPlanningComponent} from './setlist-planning/setlist-planning.component';
import {SmartGridComponent} from './smart-grid/smart-grid.component';
import {TrackComponent} from './track/track.component';
import {MatListModule} from '@angular/material/list';
import {PipesModule} from '../../pipes/pipes.module';
import {MatIconModule} from '@angular/material/icon';
import {SetlistPlanningItemComponent} from './setlist-planning/setlist-planning-item/setlist-planning-item.component';
import {MwFormsModule} from '../forms/forms.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {PlayBtnPlaylistComponent} from '../buttons/play-btn-playlist/play-btn-playlist.component';
import {SetlistClockComponent} from './setlist-clock/setlist-clock.component';
import {SharedModule} from '../../shared.module';
import {DirectivesModule} from '../../directives/directives.module';
import {MatRippleModule} from '@angular/material/core';
import {ImagesModule} from '../images/images.module';
import {ButtonsModule} from '../buttons/buttons.module';
import {TranslateService} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [
    ItemSelectorComponent,
    ListCounterComponent,
    SetlistPlanningComponent,
    SmartGridComponent,
    TrackComponent,
    SetlistPlanningItemComponent,
    PlayBtnPlaylistComponent,
    SetlistClockComponent
  ],
  exports: [
    ListCounterComponent,
    TrackComponent,
    SmartGridComponent,
    ItemSelectorComponent,
    SetlistPlanningComponent,
    SetlistClockComponent,
    PlayBtnPlaylistComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DirectivesModule,
    MatListModule,
    PipesModule,
    MatIconModule,
    MwFormsModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    ImagesModule,
    ButtonsModule,
    MatButtonModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ListsModule {

  constructor(private translate: TranslateService) {
    translate.currentLang = '';
    if (translate.getBrowserLang() === 'fr') {
      translate.setDefaultLang('fr');
      translate.use('fr');
    } else {
      translate.use(navigator.language.slice(0, 2));
    }
  }
}
